export default __webpack_public_path__ + "static/info-style-2e7a597b1de7a77d53e39920893adcf1.png";